import Exception from '@/exceptions/Exception'

export default class ServerErrorException extends Exception {
	constructor (message) {
		super(message, 'ServerErrorException')
	}
}
